"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var types_1 = require("../types");
var container_1 = require("./container");
var divider_1 = require("./divider");
var link_1 = require("./link");
var title_1 = require("./title");
function Menu(props) {
    var items = props.items, onItemClick = props.onItemClick, children = props.children, testId = props.testId;
    if (!children && !items) {
        throw new Error('Item or Children must be used.');
    }
    if (children) {
        return react_1.default.createElement(container_1.MenuContainer, { onItemClick: onItemClick }, children);
    }
    return (react_1.default.createElement(container_1.MenuContainer, { onItemClick: onItemClick, testId: testId }, items.map(function (item, index) {
        var _a;
        if (item.type === types_1.MenuItemType.DIVIDER) {
            return react_1.default.createElement(divider_1.MenuItemDivider, { key: "divider-".concat(index) });
        }
        if (item.type === types_1.MenuItemType.TITLE) {
            var title = item.title;
            return react_1.default.createElement(title_1.MenuItemTitle, { key: "".concat(title, "-").concat(index) }, title);
        }
        if (item.type === types_1.MenuItemType.LINK) {
            return (react_1.default.createElement(link_1.MenuItemLink, { key: "".concat((_a = item.href) !== null && _a !== void 0 ? _a : '-', "-").concat(item.label, "-").concat(index), href: item.href || '#', isDisabled: item.isDisabled, onClick: item.onClick, target: item.target, testId: item.testId }, item.label));
        }
        throw new Error('Invalid MenuItemType');
    })));
}
exports.Menu = Menu;
//# sourceMappingURL=menu.js.map